import { useEffect, useRef, useState } from "react";
import { UserContext } from "vagaro-website-rendering/src/components/Definitions/UserContext";
import "../../Style/Blogging.scss";

import {ArchivePost, BlogPostInfo,BlogPostStatus,CreateBlogPost,DeleteBlogPost,DuplicateBlogPost, GetAllBlogPosts, GetPostInfoArrayFromResponse, GetPostStatusString as GetPostStatusDef} from "vagaro-website-rendering/src/components/Utilities/BlogAPI";
import ReactDOM from "react-dom";
import XIcon from "vagaro-website-rendering/src/components/Icons/XIcon";
import { AlertConfirm, DestructiveConfirmation } from "../ConfirmationPopups";
import Loader from "components/Common/Loader";
import { OpenBlogSettingsPopup } from "./BlogSettingsPopup";
import Toast from "../Toast";
import WebDesigner from "../WebDesigner";
import { wBComponentTypeNames } from "vagaro-website-rendering/src/components/Definitions/WBComponentTypeNames";
import { ApplyBlogHeadingFromBlogInfo } from "../WBComponents/BlogHeading";
import { missingImageUrl } from "vagaro-website-rendering/src/components/BusinessControls/RenderBlogList";
import { SearchXIcon } from "vagaro-website-rendering/src/components/BusinessControls/RenderBlogSearch";


function SearchIcon() {
  return <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 512 512" fill="currentColor" style={{ position: "absolute", left: "10px", top: "12px", pointerEvents: "none" }}><path d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z" /></svg>
}

const enum SortType{
    None,
    TitleAcc,
    TitleDec,
    DateAcc,
    DateDec,
    AuthorAcc,
    AuthorDec,
    StatusAcc,
    StatusDec,
    ImageAcc,
    ImageDec,
    TagsAcc,
    TagsDec,
    CatAcc,
    CatDec
}

const SortStatusAcc = (a:BlogPostInfo,b:BlogPostInfo)=>{
  return GetPostStatusDef(a).name.localeCompare(GetPostStatusDef(b).name);

}
const SortStatusDec = (a:BlogPostInfo,b:BlogPostInfo)=>{
  
   return GetPostStatusDef(b).name.localeCompare(GetPostStatusDef(a).name);

}

const SortTitleAcc = (a:BlogPostInfo,b:BlogPostInfo)=>{
    return (a.title??"").localeCompare(b.title??"");
}

const SortTitleDec = (a:BlogPostInfo,b:BlogPostInfo)=>{
    return (b.title??"").localeCompare(a.title??"");
}

const SortDateAcc = (a:BlogPostInfo,b:BlogPostInfo)=>{
 
    let dateA = new Date(a.publishDate??new Date("1/1/1977"));
    let dateB = new Date(b.publishDate??new Date("1/1/1977"));
    return dateA.getTime()-dateB.getTime();
}

const SortDateDec = (a:BlogPostInfo,b:BlogPostInfo)=>{
    let dateA = new Date(a.publishDate??new Date("1/1/1977"));
    let dateB = new Date(b.publishDate??new Date("1/1/1977"));
    return dateB.getTime()-dateA.getTime();

 
}

const SortAuthorAcc = (a:BlogPostInfo,b:BlogPostInfo)=>{
    return (a.author??"").localeCompare(b.author??"");
}

const SortAuthorDec = (a:BlogPostInfo,b:BlogPostInfo)=>{
    return (b.author??"").localeCompare(a.author??"");
}

const SortImageAcc = (a:BlogPostInfo,b:BlogPostInfo)=>{
    return (a.image??"").localeCompare(b.image??"");

}

const SortImageDec = (a:BlogPostInfo,b:BlogPostInfo)=>{
  return (b.image??"").localeCompare(a.image??"");
}

const SortTagsAcc = (a:BlogPostInfo,b:BlogPostInfo)=>{

    return a.tags.join("").localeCompare(b.tags.join(""));
}
const SortTagsDec = (a:BlogPostInfo,b:BlogPostInfo)=>{
    return b.tags.join("").localeCompare(a.tags.join(""));
}
const SortCatsAcc = (a:BlogPostInfo,b:BlogPostInfo)=>{

  return a.category.join("").localeCompare(b.category.join(""));
}
const SortCatsDec = (a:BlogPostInfo,b:BlogPostInfo)=>{
  return b.category.join("").localeCompare(a.category.join(""));
}





export default function BlogBrowser({userContext,onOpenPost,onClose,currentPost}:{currentPost:string,userContext:UserContext,onOpenPost:(id:string)=>void,onClose:()=>void}){

    const [blogPosts,setBlogPosts] = useState<BlogPostInfo[]>([]);
    const [isLoading,setIsLoading] = useState(true);
    const [filteredPosts,setFilteredPosts] = useState<BlogPostInfo[]>([]);

    const [sortType,setSortType] = useState<SortType>(SortType.DateDec);

    const [menuOpen,setMenuOpen] = useState(false);
    const [menuOffset,setMenuOffset] = useState(0);
    const [menuOffsetX,setMenuOffsetX] = useState(0);
    const containerRef = useRef<HTMLDivElement>(null);
    const menuRef = useRef<HTMLDivElement>(null);
    const [filterText,setFilterText] = useState("");
    const [selectedPost,setSelectedPost] = useState<BlogPostInfo|null>(null);

    const checkTopClick = (e:any)=>{

      if(e.clientY<50){
        onClose();
      }
    }

    const sort = (t:SortType)=>{

        setSortType(t);
        setFilteredPosts(sortPosts(filteredPosts,t));
    }

    const clickHandler = (e:any)=>{

      if(menuRef.current){
        let target = e.target as HTMLElement;
        if(!menuRef.current.contains(target)){
          setTimeout(()=>setMenuOpen(false),20);
          

      }
    }

    }

   function DeleteBlogPostWithConfirmation(post:BlogPostInfo,allPosts:BlogPostInfo[],updatePosts:(posts:BlogPostInfo[])=>void){


    DestructiveConfirmation(`The blog post ${post.title??""} will be permanently deleted`,()=>{
  
        setIsLoading(true);
        DeleteBlogPost(userContext,post.id,(data:any)=>{
          setIsLoading(false);
          let posts = [...allPosts];
          let index = posts.indexOf(post);
          posts.splice(index,1);
          updatePosts([...posts]);
          Toast("Blog Post Deleted");
          if((window as any).webDesigner){
            let des = (window as any).webDesigner as WebDesigner;
            let info = des.state.postInfo;
            if(info.id == post.id){
                des.tryLoadPage(des.props.siteData.homePageId);
            }
          }

        },(data:any)=>{ 
          AlertConfirm("Error Deleting Blog Post, Please Try Again");
          setIsLoading(false);
        });
  
      },()=>{},"delete-post-confirmation","Delete Blog Post","Delete Post","Cancel");
  
  
  
  
  }

  function Init(){
    GetAllBlogPosts(userContext,(data:any)=>{
      let posts = GetPostInfoArrayFromResponse(data);
      setIsLoading(false);
      setBlogPosts(posts);
    },
    (data:any)=>{});
  }


    useEffect(()=>{
      Init();

      document.addEventListener("click",checkTopClick);
      return ()=>document.removeEventListener("click",checkTopClick);

//eslint-disable-next-line
    },[])

    useEffect(()=>{
        setFilteredPosts(sortPosts(blogPosts,sortType));
//eslint-disable-next-line
    },[blogPosts])

    useEffect(()=>{

      document.addEventListener("click",clickHandler);
      return ()=>document.removeEventListener("click",clickHandler);
//eslint-disable-next-line
    },[])

    const sortPosts = (blogPosts:BlogPostInfo[],sortType:SortType):BlogPostInfo[]=>{

        switch(sortType){
            case SortType.TitleAcc:
                return blogPosts.sort(SortTitleAcc);
            case SortType.TitleDec:
                return blogPosts.sort(SortTitleDec);
            case SortType.DateAcc:
                return blogPosts.sort(SortDateAcc);
            case SortType.DateDec:
                return blogPosts.sort(SortDateDec);
            case SortType.AuthorAcc:
                return blogPosts.sort(SortAuthorAcc);
            case SortType.AuthorDec:
                return blogPosts.sort(SortAuthorDec);
            case SortType.StatusAcc:
                return blogPosts.sort(SortStatusAcc);
            case SortType.StatusDec:
                return blogPosts.sort(SortStatusDec);
            case SortType.ImageAcc:
                return blogPosts.sort(SortImageAcc);
            case SortType.ImageDec:
                return blogPosts.sort(SortImageDec);
            case SortType.TagsAcc:
                return blogPosts.sort(SortTagsAcc);
            case SortType.TagsDec:
                return blogPosts.sort(SortTagsDec);
            case SortType.CatAcc:
                return blogPosts.sort(SortCatsAcc);
            case SortType.CatDec:
                return blogPosts.sort(SortCatsDec);

            default:
                return blogPosts;

        }
    }

    function NoResults (){
        return <div className="no-results flex-column w-full   center-all gap-large" >
        <div><svg xmlns="http://www.w3.org/2000/svg" fill="#333" height={"2em"} viewBox="0 0 512 512"><path d="M168 80c-13.3 0-24 10.7-24 24l0 304c0 8.4-1.4 16.5-4.1 24L440 432c13.3 0 24-10.7 24-24l0-304c0-13.3-10.7-24-24-24L168 80zM72 480c-39.8 0-72-32.2-72-72L0 112C0 98.7 10.7 88 24 88s24 10.7 24 24l0 296c0 13.3 10.7 24 24 24s24-10.7 24-24l0-304c0-39.8 32.2-72 72-72l272 0c39.8 0 72 32.2 72 72l0 304c0 39.8-32.2 72-72 72L72 480zM176 136c0-13.3 10.7-24 24-24l96 0c13.3 0 24 10.7 24 24l0 80c0 13.3-10.7 24-24 24l-96 0c-13.3 0-24-10.7-24-24l0-80zm200-24l32 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-32 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 80l32 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-32 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zM200 272l208 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-208 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 80l208 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-208 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z"/></svg></div>
        
        <h4>No Matching Blog Posts</h4>

        <button className="w-button w-button-primary" style={{height:"40px"}} onClick={()=>{
          let btn = document.getElementById('create-post-btn');
          if(btn)
            btn.click();
        }}>Create New Post</button>
    </div>
    }

    function filterSearch(search:string){

        let searchArray = search.trim().toLowerCase().split(" ");
        let filtered = blogPosts.filter(post=>{

            let smartArray = [...(post.title??"").toLowerCase().split(" "),...(post.author??"").toLowerCase().split(" "),GetPostStatusDef(post).name.toLowerCase(),(post.publishDateStr??"").toLowerCase()];
            for(let tag of post.tags){
                smartArray.push(tag.toLowerCase());
            }
            let found =false;
            for(let j = 0; j < searchArray.length; j++){
                found = false;
                for(let i = 0;i<smartArray.length;i++){
       
               
                    if(smartArray[i].includes(searchArray[j])){
                        found = true;
                        break;
                    }
                }
                if(!found)
                    return false;
            
            }

            return true;
           
        })

        setFilteredPosts(sortPosts(filtered,sortType));

    }


    return (
      <div className="blog-browser-wrapper w-full flex-column h-full">
        {isLoading && <Loader/>}
        <h2 style={{margin:"16px 0 -4px 16px",fontSize:"26px"}} className="title-heading">Blog Posts</h2>
        <div className="blog-heading-top flex-row  gap-large">
          <div
            className="wb-input-group flex-row no-border  justify-between gap-med"
            style={{ paddingLeft: "16px" }}
          >

      <div className="flex-row gap-med">

                  <button className="publish-button" id='create-post-btn' style={{height:"40px"}}
                  onClick={()=>{
                    setIsLoading(true);
                    let newName = "New Post";
                    let newSlug = "new-post";
                    let ni = 1;
                    //eslint-disable-next-line
                    while(blogPosts.find(p=>p.title==newName)){
                      ni++;
                      newName = "New Post "+ni;
                 
                    }
                    let i = 1;
                    //eslint-disable-next-line
                    while(blogPosts.find(p=>p.slug==newSlug)){
                      i++;
                      newSlug = "new-post-"+i;
                    }


                    CreateBlogPost(userContext,(data:any)=>{
              
                      if(data.data.data.id){
                        onOpenPost(data.data.data.id);
                        
                      }

                      setIsLoading(false);

                    },(data:any)=>{
                      AlertConfirm("Error Creating Blog Post");

                      setIsLoading(false);

                    },newName,newSlug);


                  }}
                  
                  >Create New Post</button>
                  <div className="relative">
                    <SearchIcon/>
                              <input
              type="text"

              placeholder="Search Blog Posts"
              style={{ width: "400px",paddingLeft:"32px" }}
              onInput={(e) => {
                filterSearch((e.target as HTMLInputElement).value);
                setFilterText((e.target as HTMLInputElement).value);
              }}
            />
            {filterText.length>0&& <SearchXIcon onClick={() => {
              let input = document.querySelector(".blog-browser-wrapper input");
              if (input) {
                (input as HTMLInputElement).value = "";
                filterSearch("");
                setFilterText("");
              }
            }} right="0px" height="45%" top="20%" /> }
            </div>
                  </div>

                  <div className="flex-row gap-med" style={{marginRight:"100px"}}>



              </div>
          </div>
          
        </div>
        <div
          className={
            "blog-browser-content w-full flex-row flex-wrap align-start scrollable list"
          }
        >
          

            <div className="w-full h-full relative" ref={containerRef}>
               
            <table className="blog-table" style={{ width: "100%" }}>
              <tbody>
                <tr
                className="blog-table-header"
 
                >
                  <th
                    style={{ paddingLeft: "24px", width: "120px" }}
                    onClick={() => {
                      sort(
                        sortType == SortType.ImageAcc
                          ? SortType.ImageDec
                          : SortType.ImageAcc
                      );
                    }}
                  ><div>
                    <span>Image</span>
                    {sortType == SortType.ImageAcc && <SortCaretAcc />}
                    {sortType == SortType.ImageDec && <SortCaretDec />}
                    </div>
                  </th>
                  <th
                    onClick={() => {
                      sort(
                        sortType == SortType.TitleAcc
                          ? SortType.TitleDec
                          : SortType.TitleAcc
                      );
                    }}
                  ><div>
                    <span>Title</span>
                    {sortType == SortType.TitleAcc && <SortCaretAcc />}
                    {sortType == SortType.TitleDec && <SortCaretDec />}
                    </div>
                  </th>

                  <th
                    onClick={() => {
                      sort(
                        sortType == SortType.AuthorAcc
                          ? SortType.AuthorDec
                          : SortType.AuthorAcc
                      );
                    }}
                  ><div>
                    <span>Author</span>
                    {sortType == SortType.AuthorAcc && <SortCaretAcc />}
                    {sortType == SortType.AuthorDec && <SortCaretDec />}
                    </div>
                  </th>

                  <th
                    onClick={() => {
                      sort(
                        sortType == SortType.DateAcc
                          ? SortType.DateDec
                          : SortType.DateAcc
                      );
                    }}
                  ><div>
                    <span>Publish Date</span>
                    {sortType == SortType.DateAcc && <SortCaretAcc />}
                    {sortType == SortType.DateDec && <SortCaretDec />}
                    </div>
                  </th>
                  <th
                    onClick={() => {
                      sort(
                        sortType == SortType.CatAcc
                          ? SortType.CatDec
                          : SortType.CatAcc
                      );
                    }}
                  ><div>
                    <span>Categories</span>
                    {sortType == SortType.CatAcc && <SortCaretAcc />}
                    {sortType == SortType.CatDec && <SortCaretDec />}
                    </div>
                  </th>
                  <th
                    onClick={() => {
                      sort(
                        sortType == SortType.TagsAcc
                          ? SortType.TagsDec
                          : SortType.TagsAcc
                      );
                    }}
                  ><div>
                   <span> Tags</span>
                    {sortType == SortType.TagsAcc && <SortCaretAcc />}
                    {sortType == SortType.TagsDec && <SortCaretDec />}
                    </div>
                  </th>
                  <th
                  style={{width:"140px"}}
                
                    onClick={() => {
                      sort(
                        sortType == SortType.StatusAcc
                          ? SortType.StatusDec
                          : SortType.StatusAcc
                      );
                    }}
                  ><div>
                   <span> Status</span>
                    {sortType == SortType.StatusAcc && <SortCaretAcc />}
                    {sortType == SortType.StatusDec && <SortCaretDec />}
                    </div>
                  </th>
                  <th style={{width:"50px"}}><div className="w-full"></div></th>
                </tr>
                {/* {filteredPosts.length==blogPosts.length&&
            <tr><td style={{padding:"16px"}} colSpan={6}><button className="invisible-button w-full" onClick={onCreatePost}>+ Create New Post</button></td></tr>
            } */}

                {filteredPosts.map((post, index) => (
                  <BlogPostLine
                    menuOpen={menuOpen}
                  isHighlighted={selectedPost?.id == post.id && menuOpen}
                    isCurrent={currentPost == post.id}
                    onOpenMenu={(dom:HTMLElement,xClick?:number)=>{
                      setSelectedPost(post);
                      if(containerRef.current){
                      setMenuOpen(true);

                      let clickBounds = dom.getBoundingClientRect();
                      let containerBounds = containerRef.current.getBoundingClientRect();
                      let offset = clickBounds.y-containerBounds.y;
                      setMenuOffset(offset);
                      
                      if(xClick){
                        let x = window.innerWidth - xClick - 140;
                        if(x<4){
                          x = 4;
                        }
                        setMenuOffsetX(x);
                      }
                      else{
                      setMenuOffsetX(0);
                      }
                 
                    }

                    }}
                    key={index + post.title}
                    onSelect={() => {
                      onOpenPost(post.id);
                    }}
                    postInfo={post}
                  />
                ))}
              </tbody>
            </table>
            <br/>
            {filteredPosts.length <= 0 &&!isLoading&& <NoResults />}
                {menuOpen&&selectedPost&&<div className="context-menu" ref={menuRef} style={{padding:"4px 0px",top:(menuOffset+24)+"px",right:(menuOffsetX+12)+"px",width:"140px",background:"white",position:"absolute",zIndex:500,borderRadius:"8px",overflow:"auto",boxShadow:"0 4px 8px 8px #00000033"}}>

                    <button className="invisible-button gray-hover w-full text-align-left"style={{padding:"8px 12px"}}
                    onClick={()=>{onOpenPost(selectedPost.id);setMenuOpen(false);}}
                    >Edit</button>

                    <button className="invisible-button gray-hover w-full text-align-left"style={{padding:"8px 12px"}} 
                    onClick={()=>{
                      setIsLoading(true) ;

                      let newName = selectedPost.title+" (Copy)";
                      //eslint-disable-next-line
                      while(blogPosts.find(p=>p.title==newName)){
                        newName = newName+" (Copy)";
                      }

                      DuplicateBlogPost(newName,userContext,selectedPost.id,(data:any)=>{ 
                      
                     
                        let newPost = {...selectedPost};
                        newPost.title = newName;
                        newPost.status = BlogPostStatus.Draft;
                        newPost.id = data.id;
                        newPost.status = BlogPostStatus.Draft;
                        newPost.publishDate = undefined;
                        newPost.date = "";
                        newPost.publishDateStr = undefined;
                        setIsLoading(false);
                        setBlogPosts([...blogPosts,newPost]);
                        setMenuOpen(false);
                        Toast("Blog Post Duplicated");
                        onOpenPost(newPost.id);setMenuOpen(false);


                      },(data:any)=>{
                        setIsLoading(false);
                       AlertConfirm("Error Duplicating Blog Post, Please Try Again");
                      });

                     
                        setMenuOpen(false);

                    }}>Duplicate</button>
                                        <button className="invisible-button gray-hover w-full text-align-left"style={{padding:"8px 12px"}}
                      onClick={()=>{
                        
                        OpenBlogSettingsPopup(userContext,selectedPost,blogPosts,()=>{} ,()=>{
                          
                         
                          setFilteredPosts([...filteredPosts])});
                      
                        setMenuOpen(false);

                        if((window as any).webDesigner){
                          let des = (window as any).webDesigner as WebDesigner;
                          let info = des.state.postInfo;
                          if(info.id == selectedPost.id){
                            let root = des.state.layout;
                            let heading = root.children.find(c=>c.typename == wBComponentTypeNames.blogHeading);

                            if(heading){
                              ApplyBlogHeadingFromBlogInfo(heading,selectedPost);
                              heading.forceUpdate();
                            }

                             des.flagDirtySave();
                             
                          }
                        }


                      }}
                    
                    >Post Settings</button>
                   <button className="invisible-button gray-hover w-full text-align-left"style={{padding:"8px 12px"}} 
                    onClick={()=>{
                     
                 
                      
                      setMenuOpen(false); DeleteBlogPostWithConfirmation(selectedPost,blogPosts,setBlogPosts);}}>Delete</button>
                
                   { !selectedPost.isArchive&&selectedPost.status == 2&& <button className="invisible-button gray-hover w-full text-align-left"style={{padding:"8px 12px"}} onClick={()=>{
                      setMenuOpen(false);
                      ArchivePost(userContext,selectedPost.id,(data:any)=>{
                        Toast("Blog post is archived");
                      
                          selectedPost.isArchive =true;
                          setFilteredPosts([...filteredPosts]);
                      },(data:any)=>{AlertConfirm("Error Archiving Blog Post, Please Try Again")});

                 
                      }}>Archive</button> }
                </div>
                }

          


            </div>
        
     
        </div>
      </div>
    );

}




export function BlogSettingsPopup({postInfo}:{postInfo:BlogPostInfo}){


}





function BlogPostLine({menuOpen,onSelect,onOpenMenu,postInfo,isCurrent,isHighlighted}:{isHighlighted:boolean,isCurrent:boolean,menuOpen:boolean, onOpenMenu:(domSrc:HTMLElement,xClick?:number)=>void, onSelect:()=>void, postInfo:BlogPostInfo}){

 
  let image = postInfo.image;

  if(typeof postInfo.category == "string"){
    postInfo.category = [];
  }
    if(image.length<=0){
        image = missingImageUrl;
    }

    let statusDef = GetPostStatusDef(postInfo);
    // let statColor = GetStatusColor(postInfo.status);

    return <tr className={"post-row "+(isHighlighted?" selected":"") }
    onContextMenu={(e)=>{
      if(!menuOpen){
      e.preventDefault();
      onOpenMenu(e.currentTarget,e.clientX);
      }

    }}

    onClick={ ()=>{!menuOpen&& onSelect()}}

    style={{backgroundColor:isCurrent?"#efefef":""}}
    >
        <td style={{paddingLeft:"24px"}}><img alt='blog preview' className="blog-img-preview" width={50} height={50} style={{objectFit:"cover",borderRadius:"4px"}} src={image}></img> </td>
        <td><div className="ellipsis w-full" >{postInfo.title}</div></td>
        <td>{postInfo.author}</td>
        <td>{postInfo.publishDateStr??""}</td>
        <td><div className="tag-chip-row" style={{width:"auto"}}>{postInfo.category.map((t,i:number)=>{
            return <div key={i} className="tag-chip category">{t}</div>
        })}</div></td>
        <td><div className="tag-chip-row" style={{width:"auto"}}>{postInfo.tags.map((t,i:number)=>{
            return <div key={i} className="tag-chip">{t}</div>
        })}</div></td>
        <td ><div className="flex-row"><div style={{background:statusDef.color,color:"white",fontSize:"12px",fontWeight:"500",borderRadius:"3px",margin:"2px",width:"fit-content",padding:"4px 8px"}} >{statusDef.name}</div></div></td>
        <td className="" style={{width:"50px"}} >
          <div className="center-all " style={{minWidth:"40px",maxWidth:"40px",minHeight:"3em",borderRadius:"8px"}}
          onClick={(e)=>{
            e.preventDefault();
            e.stopPropagation();
            onOpenMenu(e.currentTarget);
          }}

  
          
          >
          <svg xmlns="http://www.w3.org/2000/svg" height={"1em"} fill="currentColor" viewBox="0 0 128 512"><path d="M64 360a56 56 0 1 0 0 112 56 56 0 1 0 0-112zm0-160a56 56 0 1 0 0 112 56 56 0 1 0 0-112zM120 96A56 56 0 1 0 8 96a56 56 0 1 0 112 0z"/></svg>
          </div>
        </td>
    </tr>
}




function SortCaretAcc(){

    return <svg xmlns="http://www.w3.org/2000/svg" height="1em" fill="currentColor" viewBox="0 0 320 512"><path d="M137.4 374.6c12.5 12.5 32.8 12.5 45.3 0l128-128c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8L32 192c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l128 128z"/></svg>

}

function SortCaretDec(){

    return <svg xmlns="http://www.w3.org/2000/svg"  height="1em" fill="currentColor" viewBox="0 0 320 512"><path d="M182.6 137.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8l256 0c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-128-128z"/></svg>
}



export function BlogBrowserWrapper({context,onClose,onOpenPost,onCreatePost,currentPost}:{currentPost:string,context:UserContext,onClose:()=>void,onOpenPost:(post:string)=>void,onCreatePost:()=>void}){

    const domRef = useRef<any>(document.getElementById("blog-editor-portal"));

    

    if(!domRef.current){
        let dom = document.createElement("div");
        dom.id = "blog-editor-portal";
        document.body.appendChild(dom);
        domRef.current = dom;
    }
    

    return ReactDOM.createPortal(<> <div className="block-edit blog-wrapper full-size-panel  no-delay center-all"  > 

        <div className="relative w-full h-full flex-column" style={{background:"white"}}>
        
        <button className="invisible-button font-large" style={{position:"absolute",fontSize:"16px",top:"12px",right:"18px",zIndex:4}} onClick={onClose}><XIcon/></button>

            <BlogBrowser onClose={onClose} currentPost={currentPost} onOpenPost={onOpenPost} userContext={context}/>
        
        </div>
    </div></>,domRef.current);

}
